
import { Base } from '../base-component';

import './video.component.scss';
import { MediaQueryService } from '../../services/media-query.service';

export class Video extends Base {

	playerRatioLarge: number;
	playerRatioSmall: number;

	banner: HTMLElement;
	playerContainer: HTMLElement;
	playerContent:HTMLElement;
	player: any;
	video: any;
	closeButton: HTMLElement;
	playButton: HTMLElement;
	isExternal: boolean;

	constructor(element: Element ) {

		super(element);

		this.playerRatioLarge = 854/480;
		this.playerRatioSmall = 290/180;

	}

	init() {
		this.banner = this.element.querySelector('.js-video-container') as HTMLElement;
		this.playerContainer = this.element.querySelector('.video__player-container') as HTMLElement;
		this.playerContent = this.element.querySelector('.video__player-content') as HTMLElement;
		this.player = this.playerContainer.querySelector('.ot-video-containingBlock');
		this.video = this.element.querySelector('video');
		this.closeButton = this.element.querySelector('.js-close-video') as HTMLElement;
		this.playButton = this.element.querySelector('.js-open-video') as HTMLElement;
		
		if(this.element.classList.contains('js-no-image')){
			this.showVideoNoImage(this.playButton);
		}

	}

	bindEvents() {

		window.addEventListener('resize', this.onResize.bind(this));
		window.addEventListener('orientationchange', this.onResize.bind(this));

		setTimeout(this.onResize.bind(this), 200);
		setTimeout(this.checkVideoPlayer.bind(this), 200);

		if(this.closeButton) {
			this.closeButton.addEventListener('click', this.hideVideo.bind(this));
		}

		if(this.playButton) {
			this.playButton.addEventListener('click', this.showVideo.bind(this));
		}

	}

	showVideo(event) {
		event.preventDefault;

		if(event.currentTarget.hasAttribute('data-youtube-id')){

			this.isExternal = true;
			let videoExternal = event.currentTarget;
			this.element.classList.add('video--playing');
			let getVideo = videoExternal.getAttribute('data-youtube-id');
			this.createIframePlayer(getVideo);
			this.analyticsService.dtmVideoTrackerAutoSpot();

		}else{
			
			this.element.classList.add('video--playing');
			this.video.player.play();
		}
	}

	hideVideo(event) {

		let removeIframe = this.playerContent.querySelector('iframe');
		if(removeIframe){
			this.playerContent.removeChild(removeIframe); 
		}

		event.preventDefault;
		this.element.classList.remove('video--playing');
		this.video.player.pause();
		
	}

	onResize() {

		this.banner.style.opacity = '1';

		this.setVideoPlayerDimensions();

	}

	checkVideoPlayer() {

		if (this.player === null) {

			setTimeout(this.checkVideoPlayer.bind(this), 200);

		} else {

			this.playerContainer.style.opacity = '1';
			this.playerContainer.style.visibility = 'visible';

			if(!this.element.classList.contains('js-no-image')) {
				this.playerContainer.style.display = 'none';
			}

		}

	}

	setVideoPlayerDimensions() {

		if(!this.isExternal){
			
			if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {
	
				this.banner.style.height = `${(this.banner.offsetWidth / this.playerRatioSmall)}px`;
				this.playerContainer.style.minHeight = `${this.banner.clientHeight}px`;
				this.playerContainer.style.height = 'auto';
				this.playerContent.style.height = 'auto';
	
			} else {
	
				this.banner.style.height = `${(this.banner.offsetWidth / this.playerRatioLarge)}px`;
				this.playerContainer.style.removeProperty('height');
				this.playerContent.style.removeProperty('height');
	
			}

		}else{

			if (MediaQueryService.getMediaQuery() === 'small' || MediaQueryService.getMediaQuery() === 'x-small') {

				this.banner.style.height = `${(this.banner.offsetWidth / this.playerRatioSmall)}px`;
				this.playerContainer.style.minHeight = `${this.banner.clientHeight}px`;

			} else {

				this.banner.style.height = `${(this.banner.offsetWidth / this.playerRatioLarge)}px`;

			}

		}

	}

	createIframePlayer(url: any){

		this.playerContent.style.height = '100%';
		this.playerContainer.style.opacity = '1';
		this.playerContainer.style.visibility = 'visible';
		this.playerContainer.style.display = 'none';
		this.playerContainer.style.height = '100%';

		let externalUrl = 'https://www.youtube.com/embed/';
		externalUrl += url;
		externalUrl += '?rel=0&amp;showinfo=0&showinfo=0&enablejsapi=1';

		let createIframe = document.createElement('iframe');
		createIframe.id = 'video__external';
		createIframe.src = externalUrl;
		createIframe.classList.add('video__iframe');

		this.playerContent.appendChild(createIframe);

	}

	createIframePlayerInit(url: any){

		this.playerContent.style.height = '100%';
		this.playerContainer.style.opacity = '1';
		this.playerContainer.style.visibility = 'visible';
		this.playerContainer.style.height = '100%';

		let externalUrl = 'https://www.youtube.com/embed/';
		externalUrl += url;
		externalUrl += '?rel=0&amp;showinfo=0&enablejsapi=1';

		let createIframe = document.createElement('iframe');
		createIframe.id = 'video__external';
		createIframe.src = externalUrl;
		createIframe.classList.add('video__iframe');

		this.playerContent.appendChild(createIframe);

	}

	showVideoNoImage(element) {
		this.playerContainer.classList.add('video--playing');
		if(element.hasAttribute('data-youtube-id')){
			this.isExternal = true;
			let videoExternal = element;
			let getVideo = videoExternal.getAttribute('data-youtube-id');
			this.createIframePlayerInit(getVideo);
			this.analyticsService.dtmVideoTrackerAutoSpot();
		}else{			
			// if(this.player) {
			// 	if(this.video){
			// 		if(this.video.player) {
			// 			this.video.player.play();
			// 			this.player.style.height = "100%";
			// 		}
			// 	}
			// }
		}
	}

}



// WEBPACK FOOTER //
// ./components/video/video.component.ts